import Box from '@/components/UI/box/Box';
import styles from './MidTermMoreFilters.module.scss';
import FilterChips from '../reusabe/filterChips/FilterChips';
import useDrawer from '@/hooks/useDrawer';
import { useRef } from 'react';
import useDevice from '@/hooks/useDevice';
import Menu from '@/components/UI/menu/Menu';
import Drawer from '@/components/UI/drawer/Drawer';
import MoreFiltersList from './moreFiltersItems/MoreFiltersItems';
import { useForm } from 'react-hook-form';
import useSearchParams from '../../../hooks/useSearchParams';
import useMidTermFilters from '@/components/search/hooks/useMidTermFilters';
import { MidTermFeatureData } from '../midTermFeature/MidTermFeature';
import { PriceRangeData } from '../midTermPriceRange/MidTermPriceRange';
import { NeighbourhoodsData } from '../midTermNeighbourhoods/MidTermNeighbourhoods';
export type MoreFiltersData = {
  bedroom_count: number;
  guests: number;
} & MidTermFeatureData & PriceRangeData & NeighbourhoodsData;
const MidTermMoreFilters = () => {
  const {
    setQuery,
    queries
  } = useSearchParams();
  const {
    midTermFeatures,
    updateQueryParams,
    clearFilters,
    extractActiveFilters,
    useSyncFormWithQuery
  } = useMidTermFilters();
  const {
    handleSubmit,
    control,
    setValue,
    reset
  } = useForm<MoreFiltersData>({
    defaultValues: {}
  });
  const {
    drawerOpen,
    drawerClose,
    isDrawerOpen
  } = useDrawer();
  const open = isDrawerOpen('MOREFILTERS');
  const closeRef = useRef<any>(null);
  const {
    isMobile
  } = useDevice();
  const onSubmit = form => {
    updateQueryParams(form, setQuery);
  };
  useSyncFormWithQuery(queries, reset);
  const handleResetFilters = async e => {
    e.stopPropagation();
    const clearedFilter = await clearFilters(queries);
    reset(clearedFilter);
    setQuery(clearedFilter);
  };
  const handleClick = () => {
    if (open) {
      drawerClose();
    } else {
      drawerOpen('MOREFILTERS');
    }
  };
  const handleClose = () => {
    drawerClose();
  };
  const getSelectedFilterCount = (queries: Record<string, any>) => {
    const active = extractActiveFilters(queries);
    let count = 0;
    if (Array.isArray(active.village)) {
      count += active.village.length;
    }
    const minPrice = Number(active.min_price);
    const maxPrice = Number(active.max_price);
    const [defaultMin, defaultMax] = [100000, 300000000];
    const isPriceFiltered = minPrice && minPrice !== defaultMin || maxPrice && maxPrice !== defaultMax;
    if (isPriceFiltered) {
      count += 1;
    }
    const ignoredKeys = new Set(['village', 'min_price', 'max_price']);
    for (const [key, value] of Object.entries(active)) {
      if (ignoredKeys.has(key)) continue;
      if (value !== undefined && value !== null && value !== '') {
        count++;
      }
    }
    return count;
  };
  const selectedFilters = getSelectedFilterCount(queries);
  return <Box className={styles['mid-term-more-filters-container']} data-sentry-element="Box" data-sentry-component="MidTermMoreFilters" data-sentry-source-file="MidTermMoreFilters.tsx">
      <FilterChips type="secondary" checked={!!selectedFilters} handleClick={handleClick} handleClean={handleResetFilters} label={selectedFilters ? `فیلتر (${selectedFilters})` : 'فیلتر‌ها'} startIcon="filter" endIcon name="midterm_more_filter" id="mid-term-more-filter" data-sentry-element="FilterChips" data-sentry-source-file="MidTermMoreFilters.tsx" />
      {!isMobile ? open && <Menu ref={closeRef} id="more-filter" open={open} handleClose={drawerClose} className={styles['filter-item-container']} menuButtonId="mid-term-more-filter">
            <MoreFiltersList handleClose={drawerClose} control={control} handleSubmit={handleSubmit} onSubmit={onSubmit} handleResetFilter={handleResetFilters} midTermFeatures={midTermFeatures} handleValue={setValue} />
          </Menu> : <Drawer open={isDrawerOpen('MOREFILTERS')} onClose={handleClose} fullHeight>
          <MoreFiltersList handleClose={drawerClose} control={control} handleSubmit={handleSubmit} onSubmit={onSubmit} handleResetFilter={handleResetFilters} midTermFeatures={midTermFeatures} handleValue={setValue} />
        </Drawer>}
    </Box>;
};
export default MidTermMoreFilters;